// extracted by mini-css-extract-plugin
export var centerText = "_76-8";
export var container = "_76-0";
export var doughnutContainer = "_76-7";
export var legend = "_76-a";
export var legendItemColorDisplay = "_76-b";
export var legendItemLabel = "_76-d";
export var legendItemValue = "_76-c";
export var lg = "_76-5";
export var maxWidth = "_76-9";
export var md = "_76-4";
export var responsive = "_76-6";
export var sm = "_76-3";
export var xs = "_76-2";
export var xxs = "_76-1";